export const AXIOME_CONNECT_API = "https://aback-d.ru";
export const AXIOME_REST = "https://api-chain.axiomechain.org";
export const AXM_DENOM = "uaxm";
export const AXM_DECIMALS = 6;

export type CosmosMsg = {
  typeUrl: string;
  value: Record<string, unknown>;
};

export function toMicro(amount: string | number, decimals = AXM_DECIMALS): string {
  const [whole, frac = ""] = String(amount).replace(/,/g, "").split(".");
  const fracPadded = (frac + "0".repeat(decimals)).slice(0, decimals);
  const raw = `${whole}${fracPadded}`.replace(/^0+(?=\d)/, "") || "0";
  return raw;
}

/** Multiply micro-amount by bps/10000 using bigint (floor). bps may exceed 10000. */
export function applyBps(amountMicro: string, bps: number): string {
  const a = BigInt(amountMicro || "0");
  const b = BigInt(Math.floor(bps));
  if (b <= 0n) return "0";
  return ((a * b) / 10_000n).toString();
}

/** Ceiling variant for max caps (max_token). */
export function applyBpsCeil(amountMicro: string, bps: number): string {
  const a = BigInt(amountMicro || "0");
  const b = BigInt(Math.floor(bps));
  if (b <= 0n) return "0";
  return ((a * b + 9999n) / 10_000n).toString();
}

/** Default client slippage: 1% (100 bps). */
export const DEFAULT_SLIPPAGE_BPS = 100;

export function fromMicro(amount: string, decimals = AXM_DECIMALS, precision = 4): string {
  const neg = amount.startsWith("-");
  const digits = neg ? amount.slice(1) : amount;
  const padded = digits.padStart(decimals + 1, "0");
  const whole = padded.slice(0, -decimals) || "0";
  const frac = padded.slice(-decimals).replace(/0+$/, "").slice(0, precision);
  const out = frac ? `${whole}.${frac}` : whole;
  return neg ? `-${out}` : out;
}

export function msgExecuteContract(params: {
  sender: string;
  contract: string;
  msg: Record<string, unknown>;
  funds?: { denom: string; amount: string }[];
}): CosmosMsg {
  return {
    typeUrl: "/cosmwasm.wasm.v1.MsgExecuteContract",
    value: {
      sender: params.sender,
      contract: params.contract,
      msg: params.msg,
      funds: params.funds ?? [],
    },
  };
}

export function buildSignPayload(messages: CosmosMsg[]): string {
  const json = JSON.stringify(messages);
  // Prefer UTF-8 safe encoding — browser btoa throws on non-Latin1 and wallets show Load Failed
  let b64: string;
  try {
    if (typeof Buffer !== "undefined") {
      b64 = Buffer.from(json, "utf8").toString("base64");
    } else if (typeof btoa === "function") {
      b64 = btoa(unescape(encodeURIComponent(json)));
    } else {
      throw new Error("no base64");
    }
  } catch {
    b64 = btoa(json);
  }
  return `axiomesignswap://${b64}`;
}
